import React from "react";
import PropTypes from "prop-types";
import { Col, Form } from "react-bootstrap";

export default function TableModifiers(props) {
  return (
    <Form>
      <Form.Row className="table-modifiers d-flex align-items-center">
        <Col />
        {props.columns.map((column, index) => (
          <Col key={column.props.label + String(index)} xs="auto">
            <div className={index === 0 ? "left-most-table-modifier" : "table-modifier"}>{column}</div>
          </Col>
        ))}
      </Form.Row>
    </Form>
  );
}

TableModifiers.propTypes = {
  columns: PropTypes.array.isRequired,
};
